import React from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toAbsoluteUrl } from '../../assets/helpers/AssetHelpers';
import './MainHeader.css';
import useReRouteHook from '../../assets/hooks/useReRouteHook';
import { BreadcrumbLoader } from '../common/JainamLoader/JainamLoader';
interface SubHeaderProps {
	title: string;
}

const SubHeader: React.FC<SubHeaderProps> = ({ title }) => {
	const { category_name } = useParams();
	const navigate = useNavigate();

	const { reRouteButtonRenderer } = useReRouteHook();
	if (!category_name) {
		navigate('/no-results-found');
		return null;
	}
	return (
		<div className="d-flex px-0">
			<div className="col-lg-12 col-12">
				<nav aria-label="breadcrumb" className="px-0 px-md-3 px-lg-0">
					<ol className="breadcrumb cursor-pointer bw_med fs-sm-14 mt-3 mt-lg-0">
						<li className="breadcrumb-item active" aria-current="page">
							{reRouteButtonRenderer({
								url: '/',
								classes: 'color1 in_reg border-0 bg-transparent',
								nameText: 'Home',
							})}
						</li>
						<li className="breadcrumb-item">
							{title ? reRouteButtonRenderer({
								url: `/category/${category_name}/`,
								classes: 'color1 in_reg border-0 bg-transparent',
								nameText: title,
							}) : <BreadcrumbLoader />}
						</li>
					</ol>
				</nav>
			</div>
		</div>
	);
};

export default SubHeader;
